export default __webpack_public_path__ + "9b03deed80bcec04afea91ea4334cb20.png";